'use client'

import { useMemo, useState } from 'react'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// Laminate / vinyl (LVT) flooring, sold by the box. A box covers a set area (m²).
export function FlooringCalculatorTool() {
  const [length, setLength] = useState('5')
  const [width, setWidth] = useState('4')
  const [waste, setWaste] = useState('10')
  const [boxCoverage, setBoxCoverage] = useState('2.2')
  const [boxPrice, setBoxPrice] = useState('300')

  const r = useMemo(() => {
    const area = toolNum(length) * toolNum(width)
    const areaWithWaste = area * (1 + toolNum(waste) / 100)
    const coverage = toolNum(boxCoverage) > 0 ? toolNum(boxCoverage) : 1
    const boxes = Math.ceil(areaWithWaste / coverage)
    return { area, areaWithWaste, boxes, cost: boxes * toolNum(boxPrice) }
  }, [length, width, waste, boxCoverage, boxPrice])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Room</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Width" value={width} onChange={setWidth} unit="m" />
            <ToolField label="Waste" value={waste} onChange={setWaste} unit="%" hint="10% typical" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Flooring box</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Box coverage" value={boxCoverage} onChange={setBoxCoverage} unit="m²/box" step="0.1" />
            <ToolField label="Box price" value={boxPrice} onChange={setBoxPrice} unit="R/box" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your flooring estimate">
        <ToolResultRow label="Room area" value={`${toolFmt(r.area, 1)} m²`} />
        <ToolResultRow label="With waste" value={`${toolFmt(r.areaWithWaste, 1)} m²`} />
        <ToolResultRow label="Boxes to buy" value={`${r.boxes} boxes`} />
        <ToolResultRow label="Estimated flooring cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
